<template>
  <div id="app" ref="app" class="app" :class="[theme, isCursorHidden, { background: showBackground }]">
    <router-view />
    <TicketsHistory v-if="userProfile.profile.id" />
    <Modal
      v-if="ticketCanceled"
      ref="modal"
      show-footer
      class="cancel-ticket-confirm"
      html-id="cancel-confirm-modal"
      @closeModal="closeCancelTicketModal"
      @closeModalOutside="closeCancelTicketModal('outside')"
    >
      <h3 slot="header">
        {{ translations.general_info }}
      </h3>
      <div slot="body">
        {{ ticketCanceledMessage }}
        <div class="modal-actions">
          <button class="button" @click="closeCancelTicketModal">
            {{ translations.ok }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <button class="button" @click="closeCancelTicketModal">
          {{ translations.ok }}
        </button>
      </div>
    </Modal>
    <Modal
      v-if="showLuckyLoserModal"
      ref="modal"
      class="lucky-loser-modal"
      width="344px"
      height="348px"
      show-footer
      @closeModal="claimBonuses()"
      @closeModalOutside="claimBonuses('outside')"
    >
      <div slot="body">
        <div class="body-message-box">
          <div class="title">
            {{ translations.general_free_bet }}
          </div>
          <div class="subtitle">
            {{ translations.general_congratulation.toUpperCase() }}
          </div>
          <span class="subtitle-2">{{ translations.general_claim_ticket }}</span>
        </div>
        <div class="action">
          <button class="button" @click="claimBonuses">
            {{ translations.general_claim.toUpperCase() }}
          </button>
        </div>
      </div>
    </Modal>
    <Modal
      v-if="showFreeBetModal"
      ref="modal"
      class="free-bet-modal"
      :class="[{ mobile: isMobile }, { desktop: isDesktop }]"
      width="344px"
      height="348px"
      show-footer
      @closeModal="claimFreeBets()"
      @closeModalOutside="claimFreeBets('outside')"
    >
      >
      <div slot="body" class="body">
        <img src="./assets/free-bet-star.png" alt="" />
        <div class="body-message-box">
          <div class="pre-title">{{ translations.general_free_bet_pre_title.toUpperCase() }}</div>
          <div class="title">{{ translations.general_free_bet }}</div>
          <div class="subtitle">{{ translations.general_congratulation.toUpperCase() }}</div>
          <span class="subtitle-2">{{ translations.general_claim_ticket }}</span>
        </div>
        <div class="action">
          <button class="button" @click="claimFreeBets">
            {{ claimFreeBetsLabel }}
          </button>
        </div>
      </div>
    </Modal>
    <Modal
      v-if="showFreeBetExpiredModal"
      ref="modal"
      class="free-bet-expired-modal"
      :class="[{ mobile: isMobile }, { desktop: isDesktop }]"
      width="344px"
      height="348px"
      show-footer
      @closeModal="toggleFreeBetExpiredModal(false)"
      @closeModalOutside="toggleFreeBetExpiredModal('outside')"
    >
      >
      <h3 slot="header">
        {{ translations.general_info }}
      </h3>
      <div slot="body">
        {{ freeBetExpiredMessage }}
      </div>
      <div slot="footer">
        <button class="button" @click="toggleFreeBetExpiredModal(false)">
          {{ translations.ok }}
        </button>
      </div>
    </Modal>
    <!-- <LandscapeNotification /> -->
  </div>
</template>

<script>
import Vue from 'vue';
import {
  has,
  merge,
  isArray,
  clone,
  isNil,
  startCase,
  assign,
  each,
  toUpper,
  lowerFirst,
  isEmpty,
  toLower,
  cloneDeep,
} from 'lodash';
import applyPalette from '@nsftx/games-sdk-js/src/utility/applyPalette';
import { eventBus } from '@nsftx/games-sdk-js';
import gtag from '@nsftx/games-sdk-js/src/utility/gtag';
import Modal from '@nsftx/games-sdk-js/src/components/Modal';
// import LandscapeNotification from '@nsftx/games-sdk-js/src/components/LandscapeNotification';
import { mapState, mapGetters, mapActions } from 'vuex';
import { BusService } from '@nsftx/games-bus';
import NoSleep from 'nosleep.js';
import integrator from '@/utility/integrator';
import translationsHelper from './utility/translationsHelper';
import webViewIntegration from '@/utility/webViewIntegration';
import { ulid } from 'ulid';
import TicketsHistory from './components/TicketsHistory';
import http from './api/http';
import bus from './utility/eventBus';
import {
  handleError,
  handleGameAnimationComplete,
  handleGameAnimationStart,
  handleGameReady,
  handlePaidUpdate,
  handleStakeUpdate,
  registerOption,
} from './utility/lnwGCMIntegrator';

export default {
  name: 'App',
  components: {
    TicketsHistory,
    Modal,
    // LandscapeNotification,
  },
  data() {
    return {
      isLoggedIn: false,
      check: null,
      checkTimeout: 10000,
      payinConnection: null,
      payinTimeout: 10000,
      ticketCanceled: false,
      canceledTicket: {},
      bonuses: [],
      stopBettingTimeout: null,
      userFreeBets: {
        count: 0,
        betStake: 0,
      },
      payinTimoutWithoutTicketCheck: null,
    };
  },
  computed: {
    ...mapState([
      'config',
      'gameState',
      'selectedBet',
      'roundId',
      'isBettingDisabled',
      'jackpotState',
      'showLuckyLoserModal',
      'showFreeBetModal',
      'isTerminal',
      'terminalUserData',
      'ticketDetailsData',
      'userIsOperator',
      'terminalMouseCursorEnabled',
      'activeComponent',
      'ticketToRebet',
      'showFreeBetExpiredModal',
      'thirdPartyInfo',
      'printedTicketsByTicketCheck',
      'nextgenStandaloneIntegration',
      'layout',
      'ticketsPaidInCurrentRound',
      'animationStartEventSent',
    ]),
    ...mapGetters([
      'translations',
      'isIsonis',
      'isMobile',
      'isTablet',
      'isDesktop',
      'firstBallColor',
      'ajsDisabled',
      'isNextGen',
      'customDomain',
      'isThirdPartyIntegration',
      'isTerminalChannel',
      'isFrontIntegration',
      'staticConfig',
    ]),
    ...mapGetters('user', ['user']),
    ...mapGetters('gamesBetslip', ['ticket', 'totalPayment', 'playerTickets']),
    ...mapState(['usePackageTranslations']),
    claimFreeBetsLabel() {
      if (this.isMobile) {
        return this.translations.general_claim;
      }
      return this.translations.general_ok;
    },
    userProfile() {
      return this.user;
    },
    getTicketDetailsAuth() {
      return btoa(`${this.config.account.uuid}:${this.terminalUserData.auth.password}`);
    },
    isAndroidPlatform() {
      return webViewIntegration.isActive() && has(window, 'WebAppListener');
    },
    ticketCanceledMessage() {
      return (
        `${this.translations.general_ticket} ${this.canceledTicket.id} ` +
        `${this.translations.general_successfully_cancelled}!`
      );
    },
    theme() {
      return this.config.ui.config.theme;
    },
    isCursorHidden() {
      if (this.isTerminal && !this.terminalMouseCursorEnabled) {
        return 'hide-cursor';
      }
      return '';
    },
    isStandAlone() {
      return this.config.ui.config.mode === 'standalone';
    },
    isGravityGateway() {
      return this.config.messageProtocol.name === 'gravityGateway';
    },
    getTicketHistoryAuthHeaders() {
      const headers = {
        Authorization: `Bearer ${this.terminalUserData.auth.token}`,
        'HTTP-X-NAB-BETSHOP-ID': this.config.betshop.id,
        'HTTP-X-NAB-COMPANY-ID': this.config.companyData.id,
        'HTTP-X-NAB-DEVICE-UUID': this.config.device.deviceUuid,
        'HTTP-X-NAB-DP': 'AdminTerminal',
        'SEVEN-LOCALE': this.config.locale,
      };
      return headers;
    },
    isSevenPlatform() {
      return this.config.platformName === 'seven';
    },
    isNextGenPlatform() {
      return this.config.platformName === 'NextGen';
    },
    isLuckyLoserActive() {
      return this.config.rawData.config.luckyLoser.on.value;
    },
    hasBonus() {
      return !!this.user.bonuses.length;
    },
    freeBetExpiredMessage() {
      return this.translations.general_free_bet_expired_message;
    },
    // Show background only on desktop web and terminal betting area
    showBackground() {
      return (
        (this.layout === 'terminal' && this.activeComponent === 'BettingArea') ||
        (this.layout === 'web' && this.isDesktop)
      );
    },
    // TODO SHOULD REFACTOR THIS WHOLE PART
    userLogged() {
      return this.userProfile.profile.logged || this.isLoggedIn;
    },
  },
  methods: {
    ...mapActions([
      'setDeviceType',
      'setUserBalance',
      'getResults',
      'getStats',
      'setGameState',
      'updateRound',
      'updateGameState',
      'setIsMobile',
      'setJackpotState',
      'toggleLuckyLoserModal',
      'toggleFreeBetModal',
      'toggleFreeBetExpiredModal',
      'setCountdownData',
      'setTicketHistoryTerminal',
      'setTicketDetailsData',
      'setLoaded',
      'setActiveComponent',
      'setTicketToRebet',
      'setUserIsOperator',
      'updateConfig',
      'clearSelection',
      'showTerminalNotification',
      'setPrintedTicketByTicketCheck',
      'removePrintedTicketByTicketCheck',
      'setBettingDisable',
      'setTicketsInCurrentRound',
      'setAnimationStartEventSent',
      'setDisplayOverlay',
      'clearDrawnBalls',
    ]),
    ...mapActions('gamesBetslip', [
      'clearBetslip',
      'setIsPayinButtonDisabled',
      'getLastTickets',
      'updateBet',
      'cancelTicket',
      'ticketCheck',
      'rebet',
      'setIsPayinInProgress',
      'payIn',
    ]),
    ...mapActions('user', [
      'getUserBalance',
      'setUserBonuses',
      'setUserFreeBets',
      'getUserFreeBets',
      'getUserBonuses',
      'updateUser',
    ]),
    ...mapActions('notifications', ['setNotification', 'clearNotification']),
    preInit() {
      const isMob = this.isMobile;
      const { isTablet } = this;
      const device = isMob ? 'mobile' : isTablet ? 'tablet' : 'desktop';
      this.setHTMLLangAttribute();
      this.setIsMobile(isMob);
      this.setDeviceType(device);
      this.setupGtag(device);
      this.setPageTitle();
    },
    init() {
      if (this.isFrontIntegration) {
        registerOption('HELP');
        if (this.staticConfig?.showSoundIcon) registerOption('MUTE');
        handleStakeUpdate(this.config.rules.minBetAmount.value);
        handlePaidUpdate(0);
      }
      this.sendLoadedEvent();
      this.setTheme();
      if (!this.isSevenPlatform && !this.isNextGenPlatform) {
        this.thirdPartyPlatformSubscribe();
      }
    },
    sendLoadedEvent() {
      if (this.isFrontIntegration) handleGameReady();
      if (window.WebAppListener) {
        window.WebAppListener.sendMessage('Slave.Loaded');
      }
      this.busService.sendMessage(
        {
          action: 'Slave.Loaded',
        },
        true,
      );
    },
    setHTMLLangAttribute() {
      document.querySelector('html').setAttribute('lang', this.config.locale);
    },
    setTheme() {
      const rootElement = document.documentElement;
      const { config } = this.config.ui;
      const baseColor = this.config.ui[config.baseColor];
      const theme = this.config.ui[config.theme];
      applyPalette.set(merge(theme, baseColor), rootElement);
    },
    thirdPartyPlatformSubscribe() {
      if (this.config.user && this.config.user.id) {
        const queryParams = this.$route.query;
        this.authUser(this.config.user);
        this.setUserBalance(this.config.user.balance);
        if (!this.isTerminal) {
          this.getLastTickets();
        }
        this.busService.addChannel('DeliveryPlatform', this.config.platformConfig.clientPlatform);
        this.busService.addChannel('Player', this.config.user.username || this.config.user.id);
        if (queryParams.casino) {
          this.busService.addChannel('Balance', `${queryParams.casino}-${this.config.user.username}`);
        }
      }
    },
    closeCancelTicketModal() {
      this.ticketCanceled = false;
    },
    formatTicketBets() {
      const bets = this.ticket.length ? this.ticket : [this.selectedBet];
      return bets.map((bet) => ({
        payin: Number(bet.stake) || Number(this.totalPayment),
        type:
          isArray(bet.cleanOutcome) && bet.cleanOutcome.length >= 6
            ? bet.cleanOutcome.length - 6
            : !isNil(bet.type)
            ? bet.type
            : bet.id,
        value: !isNil(bet.outcomeIndex)
          ? String(bet.outcomeIndex)
          : isArray(bet.cleanOutcome)
          ? bet.cleanOutcome.join(',')
          : bet.outcome.split(' ').join(','),
        numEvents: bet.numEvents || 1,
      }));
    },
    setupGtag(device) {
      if (this.config.ui.config.gtm && this.config.ui.config.gtm[device]) {
        const { code, auth, preview } = this.config.ui.config.gtm[device];
        gtag.setup(code, auth, preview);
        return;
      }
      gtag.setup();
    },
    clearCheckTimeout(timeout) {
      clearTimeout(timeout);
    },
    clearStopBettingTimeout() {
      clearTimeout(this.stopBettingTimeout);
      this.stopBettingTimeout = null;
    },
    checkTicket(requestUuid, action) {
      this.check = setTimeout(async () => {
        try {
          const response = await this.ticketCheck(requestUuid);
          const { data } = response;
          if (data.status.value.toUpperCase() !== 'PENDING') {
            if (this.isTerminal) {
              // Replace with ticket_add_success, ticket_cancel_success, ticket_payout_success
              // once npm package translations are implemented
              const actionMessages = {
                Add: this.translations['ticket.add_success'],
                Cancel: this.translations['ticket.cancel_success_to_balance'].replace(
                  '{{amount}}',
                  data.cancelledAmount?.toFixed(2) ?? data.stake?.toFixed(2) ?? data.payin?.toFixed(2),
                ),
                Payout: this.translations['ticket.payout_success_to_balance'].replace(
                  '{{amount}}',
                  data.payout?.toFixed(2),
                ),
              };

              const message = actionMessages[action] || '';

              // If ticket details are open, show ticket after action is complete
              if (this.ticketDetailsData) this.setTicketDetailsData(data);

              if (
                (action === 'Payout' && data.status.value === 'PAYEDOUT') ||
                (action === 'Cancel' && data.status.value === 'CLOSED') ||
                action === 'Add'
              ) {
                this.showTerminalNotification({
                  message,
                  type: 'success',
                  delay: 3000,
                });
              }

              const newTicket = cloneDeep(data);
              newTicket.action = action;
              newTicket.parsedResponse = newTicket.bets;
              this.mapBetsForPrint(newTicket);

              this.busService.sendMessage(
                {
                  action: 'Tickets.Update',
                  enforceEvent: true,
                  data: {
                    action,
                    ticketData: newTicket,
                    showMessage: false,
                  },
                },
                true,
              );

              if (action === 'Cancel' && (data.status.value !== 'CLOSED' || !this.isThirdPartyIntegration)) return;
              if (
                action === 'Payout' &&
                data.status.value !== 'PAYEDOUT' &&
                (!this.isThirdPartyIntegration || !this.userIsOperator)
              )
                return;
              if (
                this.printedTicketsByTicketCheck.some(
                  (printedTicket) =>
                    printedTicket.requestUuid === data.requestUuid && printedTicket.status.value === data.status.value,
                )
              )
                return;

              this.setPrintedTicketByTicketCheck(newTicket);
              this.printTicket(newTicket);
            } else {
              const message = {
                message: this.translations.general_ticket_confirmed,
                status: 'positive',
                notificationTimeout: 3000,
              };
              this.clearAndSetNotification(message);
              this.getLastTickets();
            }

            this.clearBetslip();
          }
          this.clearCheckTimeout(this.check);
          this.clearCheckTimeout(this.payinTimoutWithoutTicketCheck);
        } catch (error) {
          const message = error.response?.data?.message ?? error.message;
          if (this.isTerminal) {
            this.$busService.sendMessage(
              {
                action: 'Tickets.Update',
                enforceEvent: true,
                data: {
                  action: 'Add',
                  showMessage: false,
                  ticketData: {
                    product: 'LuckySix',
                    requestUuid,
                  },
                },
              },
              true,
            );

            this.showTerminalNotification({
              message,
              type: 'warning',
              delay: 3000,
            });
          } else {
            this.clearAndSetNotification({
              message,
              type: 'warning',
              notificationTimeout: 3000,
            });
          }
        } finally {
          this.setIsPayinButtonDisabled(false);
          this.setBettingDisable(false);
          this.setIsPayinInProgress(false);
        }
      }, this.checkTimeout);
    },
    printTicketIfNotPrinted(ticket) {
      // In case ticket update is late, check if ticket has already been printed
      if (
        this.printedTicketsByTicketCheck.some(
          (printedTicket) => printedTicket.id === ticket.id && printedTicket.status.value === ticket.status.value,
        )
      ) {
        this.removePrintedTicketByTicketCheck(ticket.id);
      } else {
        this.printTicket(ticket);
      }
    },
    printTicket(ticket) {
      const actionTypes = {
        add: 'TicketPayIn',
        payout: 'TicketPayout',
        cancel: 'TicketCancel',
      };

      const layoutNames = {
        add: 'ticketLuckySix',
        payout: 'ticketLuckySixPayout',
        cancel: 'ticketCancel',
      };

      this.$busService.sendMessage(
        {
          action: 'Peripherals.Print',
          data: {
            layoutName: layoutNames[toLower(ticket.action)],
            productId: 'LuckySix',
            data: ticket,
            additionalData: {
              clientPrintJobIdentifier: {
                id: actionTypes[toLower(ticket.action)],
                uuid: ticket.requestUuid,
              },
            },
          },
        },
        true,
      );
    },
    updateTicketRound() {
      this.ticket.forEach((bet) => {
        this.updateBet({
          ...bet,
          roundNumber: this.roundId,
        });
      });
    },
    getPrintTemplate() {
      let template = '';
      const messages = this.translations;
      const { currency } = this.config;
      const bets = this.ticket.length ? this.ticket : [this.selectedBet];
      template += 'LuckySix;';
      template += "{{ ticketDateTimeUTC | date('d.m.Y H:i:s', false) }};";
      template += `${messages.general_pay_in} {{ payin | number_format(2, '.', ',') }}${currency} `;
      template += `${messages.general_payout} {{ payout | number_format(2, '.', ',') }}${currency} `;

      return `${
        template +
        bets
          .map((bet) => {
            const betOutcome = isArray(bet.outcome) ? bet.outcome.join(',') : bet.outcome;
            const betMarket = !bet.color ? `${bet.market} ${bet.category ? bet.category : ''}` : bet.category;
            let body = '';
            let round = '';

            for (let i = 0; i < bet.numEvents; i += 1) {
              round = `${messages.general_round} : {{bets[0].eventId + ${i}}}`;
              body += `${round} `;
              body += `${betOutcome} `;
              body += `${betMarket} `;
            }
            return body;
          })
          .join('; ')
      }{{ id }}`;
    },
    authUser(auth) {
      this.updateUser({
        auth: {
          token: auth.token,
          tpToken: auth.tpToken,
        },
        profile: auth.user || auth,
      });

      this.isLoggedIn = !!auth?.user?.logged || auth.id || !!auth?.user?.id;
      if (this.isLoggedIn) {
        if (window.WebAppListener) {
          this.getUserFreeBets();
        }
      }
    },
    claimBonuses() {
      this.setUserBonuses(this.bonuses);
      this.getUserBonuses();
      this.toggleLuckyLoserModal(false);
    },
    claimFreeBets() {
      this.clearBetslip();
      this.setUserFreeBets(this.userFreeBets);
      this.toggleFreeBetModal(false);
    },
    checkForRedirect() {
      const { clientplatform } = this.config;
      const redirectUrl = this.config.company.redirect.url;
      if (clientplatform && clientplatform === 'download') {
        window.location.replace(redirectUrl);
      }
    },
    getBetTypeLabel(type) {
      const types = {
        0: 'l6_bets_normal',
        3: 'general_ticket_system',
        5: 'games_first_ball_color',
        6: 'luckysix_preballs_sum_low_high',
        7: 'games_first_ball_odd_even',
        8: 'luckysix_first_ball_low_high',
        10: 'general_preball',
        11: 'luckysix_more_preballs',
      };
      return types[type];
    },
    getBetNameLabel(bet) {
      if ([0, 1, 2, 3, 4, 10].includes(bet.type)) {
        // Standard and system bet, numbers listed
        return bet.value;
      }
      if (bet.type === 5) {
        const colors = [];
        let colorsString = '';
        let colorIndex = '';
        each([0, 1, 2, 3, 4, 5, 6, 7, 8], (n) => {
          if (parseInt(bet.value, 10) & (2 ** n)) {
            colorIndex = n === 0 ? 7 : n - 1;
            const color = translationsHelper.getOutcomeName(this.firstBallColor, colorIndex);
            colors.push(color);
            colorsString = colors.join(' ');
          }
        });
        return colorsString;
      }
      const betTypes = {
        6: {
          0: 'general_low',
          1: 'general_high',
        },
        7: {
          0: 'general_even',
          1: 'general_odd',
        },
        8: {
          0: 'general_low',
          1: 'general_high',
        },
        11: {
          0: 'general_even',
          1: 'general_odd',
        },
      };
      return this.translations?.[betTypes?.[bet.type]?.[bet.value]];
    },
    initBusService() {
      let subChannels = {};

      if (this.isTerminal) {
        subChannels = {
          Product: {
            deviceUuid: this.config.device.uuid,
          },
        };

        if (!isEmpty(this.thirdPartyInfo)) {
          const { filterMessagesBy } = this.thirdPartyInfo;
          if (filterMessagesBy && filterMessagesBy.length) {
            filterMessagesBy.forEach((filter) => {
              subChannels.Product[lowerFirst(filter.name)] = filter.value;
            });
          }
        }
      }

      this.busService = new BusService({
        environment: this.config.environment,
        platform: this.config.platformName,
        productName: this.config.productName,
        productId: this.config.productId,
        tenantId: this.config.tenantId,
        locale: this.config.locale,
        applicationName: this.config.applicationName,
        subChannels,
        useCommonEventName: true,
        adapters: [{ name: 'GcmAdapter' }],
        clientMessageProtocol: this.config.messageProtocol,
        bounceToFrames: [{ frameId: 'luckysixVisualization' }],
        customDomain: this.customDomain,
      });
      this.busService.start();
      Vue.prototype.$busService = this.busService;
      (async () => {
        if (this.isTerminal) {
          this.busService.addChannel('Device', this.config.device.uuid);
        }
        if (this.isNextGenPlatform && this.userProfile?.profile?.id) {
          this.busService.addChannel('Player', this.userProfile.profile.id);
        }
      })();
    },
    async ticketPayin() {
      this.setIsPayinInProgress(true);
      this.setBettingDisable(true);
      try {
        const response = await this.payIn({
          payload: this.formatTicketBets,
          additionalInfo: this.isIsonis
            ? {
                printTemplate: this.getPrintTemplate(),
                timezone: {
                  offset: parseInt(this.userProfile.profile.profile.timezoneOffset, 10),
                },
              }
            : null,
          providerBetslipId: ulid() || null,
        });

        const ticketData = response?.config.data ? JSON.parse(response.config.data) : null;
        // Update free bets to prevent using the same code
        if (ticketData?.ticket?.bonuses) {
          this.getUserBonuses();
        }
        // IGNITE IMPLEMENTATION
        if (this.isNextGen && response.status === 201) {
          this.setIsPayinInProgress(false);
          this.setBettingDisable(false);
          const message = {
            message: this.translations.general_ticket_confirmed,
            status: 'positive',
            notificationTimeout: 3000,
          };
          this.clearAndSetNotification(message);
          this.clearBetslip();
          this.getLastTickets();
          this.getUserFreeBets();
          if (this.isBettingDisabled && !this.animationStartEventSent) {
            this.checkIfThereAreTicketsPlayedInTheRound();
          }
          setTimeout(async () => {
            if (this.nextgenStandaloneIntegration) {
              await window.igniteInstance.getWallets().then((result) => {
                if (result.activeCurrencyBalance) {
                  this.setUserBalance(result.activeCurrencyBalance);
                }
              });
            }
          }, 1000);
        } else if (this.isSevenPlatform) {
          this.checkTicket(response.data.requestUuid, 'Add');
        } else {
          // If ticket update is missing and no ticket check api is available (playtech)
          // loader should be cleared and generic error message displayed
          this.payinTimoutWithoutTicketCheck = setTimeout(() => {
            const message = {
              message: this.translations.general_ticket_error,
              status: 'negative',
            };
            this.setNotification(message);
            this.setIsPayinInProgress(false);
            this.setBettingDisable(false);
            this.getLastTickets();
          }, this.checkTimeout);
        }
        const message = {
          message: this.translations.general_ticket_resolving,
          status: 'neutral',
        };
        this.setNotification(message);
      } catch (error) {
        if (error) {
          this.payinConnection = setTimeout(() => {
            const message = {
              message: this.translations.general_ticket_error,
              status: 'negative',
              notificationTimeout: 3000,
            };
            this.setNotification(message);
            this.setIsPayinInProgress(false);
            this.setBettingDisable(false);
            clearTimeout(this.payinConnection);
          }, this.payinTimeout);
        }
        if (error.response) {
          const errorData = error.response.data;
          const message = {
            message: errorData.message,
            status: 'negative',
          };
          this.setNotification(message);
          this.setIsPayinInProgress(false);
          this.setBettingDisable(false);
          if (this.isFrontIntegration) {
            const { category, errorCode, message, severity } = errorData.details;
            this.setDisplayOverlay(true);
            handleError(category, severity, errorCode, message);
          }
        }
      }
    },
    async ticketPayinTerminal() {
      if (this.isThirdPartyIntegration) {
        this.showTerminalNotification({
          message: this.translations.general_ticket_resolving,
          type: 'info',
          delay: null,
        });
        const regulatory = this.config.ui.config?.regulatory;
        const paymentAmount = regulatory?.triggers?.filter((action) => action.type === 'payment')[0].value;
        // ID = 1 MNE RETAIL AUTH
        if (regulatory?.id === 1 && paymentAmount && this.totalPayment >= paymentAmount) {
          this.showTerminalNotification({
            // eslint-disable-next-line dot-notation
            message: this.translations['terminal_regulatory_transaction_payin_amount_exceded']
              .replace('{{amount}}', paymentAmount)
              .replace('{{currency}}', this.config.currency),
            type: 'warning',
            delay: 3000,
          });
          return;
        }
      }
      this.setIsPayinInProgress(true);
      this.setBettingDisable(true);
      try {
        const response = await this.payIn({
          payload: this.formatTicketBets,
          additionalInfo: this.isIsonis
            ? {
                printTemplate: this.getPrintTemplate(),
                timezone: {
                  offset: parseInt(this.userProfile.profile.profile.timezoneOffset, 10),
                },
              }
            : null,
        });

        const config = {
          ticketGroup: this.config.productName,
        };
        const formatedPayload = response;
        formatedPayload.ticket.stake = response.ticket.payin;
        formatedPayload.ticket.config = config;
        if (formatedPayload.ticket.payin > this.user.balance) {
          this.showTerminalNotification({
            message: this.translations.player_balance_insufficient,
            type: 'warning',
            delay: 3000,
          });
          return;
        }
        this.busService.clientAdapter.handler
          .emitAsync({
            action: 'Tickets.Pay',
            data: formatedPayload,
            async: true,
          })
          .then((response2) => {
            this.checkTicket(response2.ticket.requestUuid, 'Add');
          });
        //  this.setNotification(message);
      } catch (error) {
        if (error) {
          this.payinConnection = setTimeout(() => {
            const message = {
              message: this.translations.general_ticket_error,
              status: 'negative',
            };
            this.setNotification(message);
            this.setIsPayinInProgress(false);
            this.setBettingDisable(false);
            clearTimeout(this.payinConnection);
          }, this.payinTimeout);
        }
        if (error.response) {
          const errorData = error.response.data;
          const message = {
            message: errorData.message,
            status: 'negative',
          };
          this.setNotification(message);
          this.setIsPayinInProgress(false);
          this.setBettingDisable(false);
        }
      }
    },
    updatePlayerChannel(playerId) {
      if (playerId) {
        this.busService.addChannel('Player', playerId);
      } else {
        this.busService.removeChannel('Player', this.userProfile.profile.id);
      }
    },
    disableBetting(notification) {
      this.setBettingDisable(true);
      this.setIsPayinButtonDisabled(this.isBettingDisabled);
      this.clearAndSetNotification(notification);
    },
    setPageTitle() {
      const { productFqn, applicationName } = this.config;
      document.title = `${startCase(productFqn)}: ${applicationName}`;
    },
    stopBettingTimout() {
      this.stopBettingTimeout = setTimeout(() => {
        this.setBettingDisable(false);
        this.setIsPayinButtonDisabled(this.isBettingDisabled);
      }, 20000);
    },
    resetUserFreeBets() {
      this.userFreeBets = {
        count: 0,
        betStake: 0,
      };
    },
    // ignitePrepareBetslipFormatBets() {
    //   const bets = this.ticket.length ? this.ticket : [this.selectedBet];
    //   return bets.map((bet) => bet.stake);
    // },
    mapRebet(ticket) {
      const bets = [];
      ticket.bets.forEach((bet) => {
        bets.push({
          value: bet.value,
          round: bet.eventId,
          market: translationsHelper.getBetName(bet, 'typeValue'),
          outcome: this.getBetNameLabelForRebet(bet),
          displayValue: this.getBetNameLabelForRebet(bet),
          outcomeIndex: this.getOutcomeIndex(bet),
          stake: bet.amount,
          odds: bet.category === 'SPECIAL' ? bet.odd : null,
          type: bet.type,
          tax: bet.tax,
        });
      });
      return bets;
    },
    getBetNameLabelForRebet(bet) {
      if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11].includes(bet.type)) {
        return bet.value;
      }
      const betTypes = {
        6: {
          0: 'general_low',
          1: 'general_high',
        },
        7: {
          0: 'general_even',
          1: 'general_odd',
        },
        8: {
          0: 'general_low',
          1: 'general_high',
        },
        11: {
          0: 'general_even',
          1: 'general_odd',
        },
      };
      return this.translations[betTypes[bet.type][bet.value]];
    },
    getOutcomeIndex(bet) {
      if ([5, 6, 7, 8, 11].includes(bet.type)) {
        return bet.outcomeIndex;
      }
      return isArray(bet.value) ? null : bet.value;
    },
    checkIsTicketFuture(ticket) {
      const { bets } = ticket;
      let isFuture = false;
      if (!bets || bets.length === 1) return isFuture;
      const firstBetRound = bets[0].eventId;
      bets.forEach((bet) => {
        if (firstBetRound !== bet.eventId) isFuture = true;
      });
      return isFuture;
    },
    mapBetsForPrint(ticket) {
      const gameName = this.usePackageTranslations ? 'product_name' : 'pages_company_help_virtual_games_lucky_six';
      ticket.translation = this.translations[gameName];
      const isFuture = this.checkIsTicketFuture(ticket);
      ticket.isFuture = isFuture;

      each(ticket.parsedResponse, (bet) => {
        const singleBet = {
          category: 'STANDARD',
          title: null,
          eventValue: null,
          value: null,
        };
        if (bet.type === 0) {
          singleBet.title = bet.value;
          singleBet.eventValue = '';
          bet.bet = singleBet;
          bet.eventValue = '';
        }
        bet.possibleTax = bet.possibleTax || 0;
        bet.displayName = this.translations[this.getBetTypeLabel(bet.type)];
        if ([1, 2, 3, 4].includes(bet.type)) {
          const systemTypes = {
            1: '6/7',
            2: '6/8',
            3: '6/9',
            4: '6/10',
          };
          bet.displayName = `${this.translations.general_ticket_system} ${systemTypes[bet.type]}`;
        }
        bet.displayValue = this.getBetNameLabel(bet);
      });
    },
    async clearAndSetNotification(notification) {
      await this.clearNotification();
      this.setNotification(notification);
    },
    handleSetState(eventDetail) {
      if (this.isTerminal) {
        if (eventDetail.type === 'ball') {
          this.setCountdownData(null);
        }
        if (eventDetail.type === 'countdown' || eventDetail.type === 'bettingDisabled') {
          const countdownData = {
            delay: eventDetail.delay,
            sentTime: eventDetail.sentTime,
            time: eventDetail.time,
          };
          this.setCountdownData(countdownData);
        }
      }
      if (eventDetail.type) {
        this.setGameState(eventDetail);
        if (this.userLogged) {
          this.getUserFreeBets();
          this.getLastTickets();
          if (this.isLuckyLoserActive) {
            this.getUserBonuses();
          }
        }
      }
      if (eventDetail.type === 'countdown') {
        this.updateRound(eventDetail.eventId);
      } else if (eventDetail.type === 'ball' || eventDetail.type === 'results' || eventDetail.type === 'new') {
        this.updateRound(eventDetail.eventId + 1);
      } else if (eventDetail.type === 'bettingDisabled') {
        this.disableBetting({
          message: this.translations.general_betting_disabled_warning,
          status: 'negative',
          notificationTimeout: 3000,
        });
        this.checkIfThereAreTicketsPlayedInTheRound(eventDetail);
        if (this.isFrontIntegration && this.ticketsPaidInCurrentRound) {
          handleGameAnimationStart();
          this.setAnimationStartEventSent(true);
          this.setDisplayOverlay(true);
        }
      }
    },
    async handleStartEvent(eventDetail) {
      // Refresh ticket details on terminal after round start to update ticket status
      setTimeout(() => {
        if (this.isTerminal && this.ticketDetailsData) {
          if (this.ticketDetailsData.status.id !== '5') {
            const path = this.config.platformDataCenter
              ? `VUE_APP_TERMINAL_TICKET_CHECK_PATH_${toUpper(this.config.platformDataCenter)}`
              : `VUE_APP_TERMINAL_TICKET_CHECK_PATH`;
            fetch(`${process.env[path]}/${this.ticketDetailsData.id}.json`, {
              headers: {
                Authorization: `Basic ${this.getTicketDetailsAuth}`,
                'SEVEN-LOCALE': this.config.locale,
              },
            })
              .then((response) => response.text())
              .then((text) => this.setTicketDetailsData(JSON.parse(text)));
          }
        }
      }, 1000);
      this.setCountdownData(null);
      this.clearStopBettingTimeout();
      this.setGameState(eventDetail);
      this.updateRound(eventDetail.eventId + 1);
      this.updateTicketRound();
      await this.setBettingDisable(false);
      await this.setIsPayinButtonDisabled(this.isBettingDisabled);
      if (this.userLogged && !this.isTerminal) {
        setTimeout(() => {
          this.getLastTickets();
        }, 500);
      }
      // Case when ticket payin has been sent before betting disabled event
      // and response arrived after it but only if the animation start event hasn't been sent yet
      if (this.isFrontIntegration && this.ticketsPaidInCurrentRound && !this.animationStartEventSent) {
        handleGameAnimationStart();
        this.setAnimationStartEventSent(true);
        this.setDisplayOverlay(true);
      }
    },
    handleDrawResult(eventDetail) {
      const currentBallEventId = eventDetail.eventId;
      const currentBallId = eventDetail.id;
      const currentBalls = clone(this.gameState.balls);
      const isCurrentBallMissing = currentBalls.findIndex((n) => n.id === currentBallId) < 0;

      if (this.stopBettingTimeout) this.clearStopBettingTimeout();

      if (isCurrentBallMissing) {
        currentBalls.push({
          ball: eventDetail.ball,
          id: eventDetail.id,
          eventId: currentBallEventId,
        });

        this.updateGameState({
          ball: eventDetail.ball,
          currentBallId,
          balls: currentBalls,
          eventId: currentBallEventId,
          eventName: eventDetail.eventName,
          sentTime: eventDetail.sentTime,
        });
      }
    },
    handleSetResults(eventDetail) {
      // Refresh ticket details on terminal after results to update ticket status
      setTimeout(() => {
        if (this.isTerminal && this.ticketDetailsData) {
          if (this.ticketDetailsData.status.id !== '5') {
            const path = this.config.platformDataCenter
              ? `VUE_APP_TERMINAL_TICKET_CHECK_PATH_${toUpper(this.config.platformDataCenter)}`
              : `VUE_APP_TERMINAL_TICKET_CHECK_PATH`;
            fetch(`${process.env[path]}/${this.ticketDetailsData.id}.json`, {
              headers: {
                Authorization: `Basic ${this.getTicketDetailsAuth}`,
                'SEVEN-LOCALE': this.config.locale,
              },
            })
              .then((response) => response.text())
              .then((text) => this.setTicketDetailsData(JSON.parse(text)));
          }
        }
      }, 1000);
      if (this.userLogged && !this.isTerminal) {
        this.getLastTickets();
        setTimeout(async () => {
          if (this.nextgenStandaloneIntegration) {
            await window.igniteInstance.getWallets().then((result) => {
              if (result.activeCurrencyBalance) {
                this.setUserBalance(result.activeCurrencyBalance);
              }
            });
          }
        }, 1000);
      }
      // We had cases where startEvent message is missing and the drawnBalls from last round arent cleared properly
      // this is a safety measure to clear them before next round starts
      this.clearDrawnBalls();
      this.setGameState(eventDetail);
      this.getResults();
      this.getStats();
      if (this.isFrontIntegration && this.ticketsPaidInCurrentRound) {
        handleGameAnimationComplete();
      }
      this.setTicketsInCurrentRound(false);
      this.setAnimationStartEventSent(false);
    },
    handleStartCountdown(eventDetail) {
      if ((this.userLogged || this.userProfile.profile.logged) && !this.isTerminal) {
        this.getLastTickets();
      }
      if (this.isStandAlone && !this.isGravityGateway) {
        this.getUserBalance();
      }
      if (this.isTerminal) {
        const countdownData = {
          delay: eventDetail.delay,
          sentTime: eventDetail.sentTime,
          time: Date.now(),
        };
        this.setCountdownData(countdownData);
      }
      if (this.isFrontIntegration && this.ticketsPaidInCurrentRound) {
        handleGameAnimationComplete();
        this.setBettingDisable(true);
      }
      this.setTicketsInCurrentRound(false);
      // We had cases where startEvent message is missing and the drawnBalls from last round arent cleared properly
      // this is a safety measure to clear them before next round starts
      this.clearDrawnBalls();
    },
    handleTerminalTicketUpdate(eventDetail) {
      if (this.isTerminal) {
        const ticket = JSON.parse(JSON.stringify(eventDetail));
        ticket.parsedResponse = ticket.bets;
        ticket.ticketPin = eventDetail.ticketPin;
        this.mapBetsForPrint(ticket);

        if (eventDetail.status.id === '0' && this.config.applicationName.toLowerCase() === 'terminal') {
          ticket.payinConfirmation = this.translations['print.payin_confirmation'];

          this.printTicketIfNotPrinted(ticket);

          this.busService.sendMessage(
            {
              action: 'Tickets.Update',
              enforceEvent: true,
              data: {
                action: 'Add',
                ticketData: ticket,
                showMessage: false,
              },
            },
            true,
          );
          this.showTerminalNotification({
            message: this.translations['ticket.add_success'],
            type: 'success',
            delay: 3000,
          });
          if (this.ticketToRebet) {
            this.setTicketToRebet(null);
          }
        }
        if (eventDetail.code) {
          const message =
            eventDetail.message === 'Insufficient funds'
              ? this.translations.player_balance_insufficient
              : eventDetail.message;
          this.showTerminalNotification({
            message,
            type: 'warning',
            delay: 3000,
          });

          this.busService.sendMessage(
            {
              action: 'Tickets.Update',
              enforceEvent: true,
              data: {
                action: 'Payout',
                ticketData: ticket,
                showMessage: false,
              },
            },
            true,
          );
          this.setIsPayinInProgress(false);
        }
        if (eventDetail.status.id === '12') {
          this.busService.sendMessage(
            {
              action: 'Tickets.Update',
              enforceEvent: true,
              data: {
                action: 'Add',
                ticketData: ticket,
                showMessage: false,
              },
            },
            true,
          );
        }
        if (eventDetail.status.id === '5') {
          this.busService.sendMessage(
            {
              action: 'Tickets.Update',
              enforceEvent: true,
              data: {
                action: 'Payout',
                ticketData: ticket,
                showMessage: false,
              },
            },
            true,
          );
          if (this.userIsOperator || this.isThirdPartyIntegration) {
            this.printTicketIfNotPrinted(ticket);
          }
          if (!this.userIsOperator) {
            this.showTerminalNotification({
              message: this.translations['ticket.payout_success_to_balance'].replace(
                '{{amount}}',
                eventDetail.payout.toFixed(2),
              ),
              type: 'success',
              delay: 3000,
            });
          }
          const path = this.config.platformDataCenter
            ? `VUE_APP_TERMINAL_TICKET_CHECK_PATH_${toUpper(this.config.platformDataCenter)}`
            : `VUE_APP_TERMINAL_TICKET_CHECK_PATH`;
          fetch(`${process.env[path]}/${ticket.id}.json`, {
            headers: {
              Authorization: `Basic ${this.getTicketDetailsAuth}`,
              'SEVEN-LOCALE': this.config.locale,
            },
          })
            .then((response) => response.text())
            .then((text) => this.setTicketDetailsData(JSON.parse(text)));
        }
        if (eventDetail.status.id === '1') {
          this.busService.sendMessage(
            {
              action: 'Tickets.Update',
              enforceEvent: true,
              data: {
                action: 'Cancel',
                ticketData: ticket,
                showMessage: false,
              },
            },
            true,
          );
          if (this.isThirdPartyIntegration) {
            this.printTicketIfNotPrinted(ticket);
          }
          this.showTerminalNotification({
            message: this.translations['ticket.cancel_success_to_balance'].replace(
              '{{amount}}',
              eventDetail.payin.toFixed(2),
            ),
            type: 'success',
            delay: 3000,
          });

          each(ticket.bets, (bet) => {
            const singleBet = {
              category: 'STANDARD',
              title: null,
              eventValue: null,
              value: null,
            };
            if (bet.type === 0) {
              singleBet.title = bet.value;
              singleBet.eventValue = '';
              bet.bet = singleBet;
              bet.eventValue = '';
            }
            bet.typeValue = this.translations[this.getBetTypeLabel(bet.type)];
          });
          this.setTicketDetailsData(ticket);
        }
        this.setIsPayinButtonDisabled(false);
        this.setIsPayinInProgress(false);
        this.clearCheckTimeout(this.check);
        this.clearCheckTimeout(this.payinTimoutWithoutTicketCheck);
        this.clearBetslip();
        this.setBettingDisable(false);
      }
    },
    handleWebTicketUpdate(eventDetail) {
      const notification = { notificationTimeout: 3000 };
      if (eventDetail.id && eventDetail.status.id === '0') {
        let message = this.translations.general_ticket_confirmed;
        let status = 'positive';
        if (eventDetail.bonuses && eventDetail.bonuses.length) {
          message = this.translations.general_free_bet_confirmed_message;
          status = 'bonus';
        }
        notification.message = message;
        notification.status = status;
        this.getUserFreeBets();
        if (this.isLuckyLoserActive && this.hasBonus) {
          this.getUserBonuses();
        }
      }
      if (eventDetail.id && eventDetail.status.id === '1') {
        notification.message = this.translations.general_ticket_canceled;
        notification.status = 'neutral';
        this.ticketCanceled = true;
        this.canceledTicket = eventDetail;
        eventBus.$emit('RefreshTicketHistory');
      }
      const ticketsResolved = {
        action: 'Tickets.Resolved',
        data: {
          accepted: true,
          ticket: eventDetail,
        },
      };

      // Send analytics message to parent frames
      if (window.WebAppListener) {
        window.WebAppListener.sendMessage(JSON.stringify(ticketsResolved));
      }
      this.busService.sendMessage(ticketsResolved, true);
      if (eventDetail.code) {
        notification.message = eventDetail.message;
        notification.status = 'negative';
        if (this.ticket.length === 1 && this.isQuickpayEnabled) {
          this.clearBetslip();
        }
      } else {
        this.clearBetslip();
      }
      this.getLastTickets();
      eventBus.$emit('SwitchToBetslipTab');
      this.clearAndSetNotification(notification);
      this.setIsPayinInProgress(false);
      this.setBettingDisable(false);
      this.clearCheckTimeout(this.check);
      this.clearCheckTimeout(this.payinTimoutWithoutTicketCheck);
      if (this.isStandAlone && !this.isGravityGateway) {
        this.getUserBalance();
      }
    },
    handleTicketsFetchHistory(eventDetail) {
      const path = this.config.platformDataCenter
        ? `VUE_APP_TERMINAL_TICKET_HISTORY_PATH_${toUpper(this.config.platformDataCenter)}`
        : `VUE_APP_TERMINAL_TICKET_HISTORY_PATH`;
      fetch(
        `${process.env[path]}/${this.config.productId}.json?deviceUuid=${this.config.device.deviceUuid}&timeFrom=${eventDetail.data.timeFrom}&timeTo=${eventDetail.data.timeTo}&count=${eventDetail.data.count}`,
        {
          headers: this.getTicketHistoryAuthHeaders,
        },
      )
        .then((response) => response.text())
        .then((text) => this.setTicketHistoryTerminal(JSON.parse(text)));
    },
    handleTicketsChecked(eventDetail) {
      const path = this.config.platformDataCenter
        ? `VUE_APP_TERMINAL_TICKET_CHECK_PATH_${toUpper(this.config.platformDataCenter)}`
        : `VUE_APP_TERMINAL_TICKET_CHECK_PATH`;
      // eslint-disable-next-line no-case-declarations
      let ticketPin = null;
      if (eventDetail.data.ticket.ticketPin) {
        ticketPin = eventDetail.data.ticket.ticketPin;
      }
      this.setLoaded(false);

      http
        .get(`${process.env[path]}/${eventDetail.data.ticket.id}.json`, {
          headers: {
            Authorization: `Basic ${this.getTicketDetailsAuth}`,
            'SEVEN-LOCALE': this.config.locale,
          },
        })
        .then((response) => {
          const formated = response.data;
          formated.ticketPin = ticketPin;
          this.setTicketDetailsData(formated);
        })
        .catch((error) => {
          this.setActiveComponent('BettingArea');
          this.showTerminalNotification({
            message: error.response.data.message,
            type: 'warning',
            delay: 3000,
          });
        });
    },
    async handleAuthorizationChanged(eventDetail) {
      if (this.isTerminal) {
        if (eventDetail.data.userType === 'OPERATOR') {
          this.setUserIsOperator(true);
        }
      }
      // eslint-disable-next-line no-case-declarations
      const authData = eventDetail.data.auth;
      if (!authData.user || !authData.user.logged) {
        this.clearSelection();
        this.resetUserFreeBets();
        this.toggleFreeBetModal(false);
        this.toggleFreeBetExpiredModal(false);
        await this.clearBetslip();
      }
      if (authData) {
        const playerId = authData?.user?.id || null;
        this.setUserBalance(authData.user.balance);
        this.updatePlayerChannel(playerId);
        this.authUser(authData);
      }
      if (this.isStandAlone && this.isGravityGateway) {
        this.getUserBalance();
      }
      if (this.isNextGen) {
        this.updateUser({
          auth: eventDetail.data?.auth,
          profile: eventDetail.data?.auth?.user,
        });
      }
      if (this.userLogged) {
        this.getUserFreeBets();
      }
    },
    checkIfThereAreTicketsPlayedInTheRound(eventDetail) {
      const ticketsInCurrentRound = this.playerTickets.filter((ticket) =>
        ticket.bets.some((bet) => bet.round === eventDetail.eventId),
      );
      if (ticketsInCurrentRound.length > 0) this.setTicketsInCurrentRound(true);
    },
  },
  // eslint-disable-next-line vue/order-in-components
  watch: {
    isLoggedIn(value) {
      if (value && !this.isTerminal) {
        this.getLastTickets();
      }
    },
    userLogged(value) {
      if (value && !this.isTerminal) {
        this.getLastTickets();
      }
    },
    totalPayment(value) {
      if (this.isFrontIntegration) handleStakeUpdate(Number(value));
    },
  },
  // eslint-disable-next-line vue/order-in-components
  beforeMount() {
    this.preInit();
    this.initBusService();
    (async () => {
      if (!this.ajsDisabled) {
        await this.setJackpotState();
        if (this.jackpotState) {
          this.busService.addChannel('Jackpot', this.jackpotState.jackpotId);
        }
      }
    })();
  },
  // eslint-disable-next-line vue/order-in-components
  mounted() {
    // eslint-disable-next-line
    console.log('STORE:', this.$store);
    if (!this.isDesktop) {
      const noSleep = new NoSleep();
      let wakeLockEnabled = false;
      document.addEventListener(
        'click',
        function enableNoSleep() {
          document.removeEventListener('click', enableNoSleep, false);
          if (!wakeLockEnabled) {
            noSleep.enable();
            wakeLockEnabled = true;
          } else {
            noSleep.disable();
            wakeLockEnabled = false;
          }
        },
        false,
      );
    }
    this.init();
    const postMsgData = {
      messageType: 'Games:Init:Acknowledged',
    };
    window.top.postMessage(postMsgData, '*');
    window.addEventListener('Bus:Message', async (event) => {
      const { eventName } = event.detail;
      const eventDetail = event.detail;
      switch (eventName) {
        case 'SetState':
          this.handleSetState(eventDetail);
          break;
        case 'StartEvent':
          this.handleStartEvent(eventDetail);
          break;
        case 'DrawResult': {
          this.handleDrawResult(eventDetail);
          break;
        }
        case 'StopBetting':
          this.disableBetting({
            message: this.translations.general_betting_disabled_warning,
            status: 'negative',
            notificationTimeout: 3000,
          });
          this.stopBettingTimout();
          this.checkIfThereAreTicketsPlayedInTheRound(eventDetail);
          if (this.isFrontIntegration && this.ticketsPaidInCurrentRound) {
            handleGameAnimationStart();
            this.setAnimationStartEventSent(true);
            this.setDisplayOverlay(true);
          }
          // We had cases where startEvent message is missing and the drawnBalls from last round arent cleared properly
          // this is a safety measure to clear them before next round starts
          this.clearDrawnBalls();
          break;
        case 'SetResults':
          this.handleSetResults(eventDetail);
          break;
        case 'StartCountdown':
          this.handleStartCountdown(eventDetail);
          break;
        case 'UI.Show': {
          this.setActiveComponent(event.detail.data.name[0]);
          break;
        }
        case 'Slave.Snooze': {
          this.setActiveComponent(null);
          break;
        }
        case 'Tickets.PayingSentSuccess':
        case 'Tickets.PayoutSentSuccess':
        case 'Tickets.CancelSentSuccess': {
          if (this.isThirdPartyIntegration) {
            const { ticket, action } = event.detail.data;
            const requestId = ticket?.requestId;
            if (requestId) {
              this.checkTicket(requestId, action);
            }
          }
          break;
        }
        case 'Tickets.PayingFailed':
        case 'Tickets.PayoutFailed':
        case 'Tickets.CancelFailed': {
          this.showTerminalNotification({
            message: event.detail.data.error,
            type: 'warning',
            delay: 3000,
          });
          this.setIsPayinButtonDisabled(false);
          this.setBettingDisable(false);
          this.setIsPayinInProgress(false);
          this.clearCheckTimeout(this.check);
          break;
        }
        case 'TicketUpdate':
          if (this.isTerminalChannel) this.handleTerminalTicketUpdate(eventDetail);
          else this.handleWebTicketUpdate(eventDetail);
          break;
        case 'Tickets.FetchHistory':
          this.handleTicketsFetchHistory(eventDetail);
          break;
        case 'Tickets.Checked':
          this.handleTicketsChecked(eventDetail);
          break;
        case 'User.AuthorizationChanged':
          this.handleAuthorizationChanged(eventDetail);
          break;
        case 'User.ProfileChanged':
          this.setUserBalance(eventDetail.data.profile.balance);
          break;
        case 'User.SettingsChanged':
          if (!this.userLogged) {
            this.resetUserFreeBets();
            this.clearBetslip();
            this.setUserFreeBets(this.userFreeBets);
          } else {
            this.getUserFreeBets();
            if (this.isLuckyLoserActive) {
              this.getUserBonuses();
            }
          }
          break;
        case 'User.BalanceChanged':
          if (eventDetail.data && !isNil(eventDetail.data.balance)) {
            const { balance } = eventDetail.data;
            this.setUserBalance(balance);
          }
          if (this.isStandAlone && this.isGravityGateway && !this.isTerminal) {
            this.getUserBalance();
          }
          break;
        case 'balanceUpdate': {
          // eslint-disable-next-line no-case-declarations
          const balanceList = eventDetail.balanceArray;
          if (balanceList.length && !isNil(balanceList[0].balanceAmt)) {
            this.setUserBalance(balanceList[0].balanceAmt);
          }
          break;
        }
        case 'Bonus':
          this.bonuses = eventDetail.rawData;
          this.toggleLuckyLoserModal(true);
          break;
        case 'FreeBet':
        case 'freebet':
          this.userFreeBets = eventDetail;
          // eslint-disable-next-line no-case-declarations
          const { subtype } = eventDetail;
          if (subtype === 'new') {
            this.toggleFreeBetModal(true);
          } else {
            if (this.userProfile.freeBets.count > 0) {
              this.toggleFreeBetExpiredModal(true);
            }
            await this.getUserFreeBets();
          }
          break;
        // IGNITE
        case 'onSettingsUpdated':
          if (this.config.locale !== eventDetail.data.activeLocale) {
            this.updateConfig({ locale: eventDetail.data.activeLocale });
            // TODO HANDLE TRANSLATIONS CHANGE
          }
          if (this.config.currency !== eventDetail.data.activeCurrencyBalance) {
            this.updateConfig({ currency: eventDetail.data.activeCurrency.code });
          }
          break;
        case 'onBettingDenied':
          this.disableBetting({
            message: this.translations.general_betting_disabled_warning,
            status: 'negative',
            notificationTimeout: 3000,
          });
          break;
        case 'onBettingAllowed':
          this.setBettingDisable(false);
          this.setIsPayinButtonDisabled(false);
          break;
        case 'onCancelBetsRequested':
          // eslint-disable-next-line no-console
          this.cancelTicket({
            id: eventDetail.data.betIds[0],
            providerBetslipId: eventDetail.data.providerBetslipId,
          });
          break;
        case 'onReBetRequested':
          // eslint-disable-next-line no-console
          this.ticketCheck(eventDetail.data.providerBetslipId).then((response) => {
            const ticket = response.data.message;
            const bets = this.mapRebet(ticket);
            const { payin } = ticket;
            this.rebet({ bets, payin }).then(() => {
              eventBus.$emit('TicketRebet');
              this.setTicketToRebet(null);
            });
          });
          break;
        default:
          break;
      }
    });
    window.addEventListener('visibilitychange', () => {
      if ((this.isMobile || this.isTablet) && this.userLogged) {
        this.getLastTickets();
      }
    });
    this.$root.$on('ReturnToLobby', () => {
      this.busService.sendMessage(
        {
          action: 'UI.Show',
          data: {
            name: 'Lobby',
          },
        },
        true,
      );
      if (window.WebAppListener) {
        window.WebAppListener.sendMessage('Navigation.Back');
      }
    });
    eventBus.$on('LoginRequired', () => {
      if (window.WebAppListener) {
        window.WebAppListener.sendMessage('User.LoginRequired');
      }
      this.busService.sendMessage(
        {
          type: 'loginRequired',
          action: 'User.LoginRequired',
        },
        true,
      );
      if (this.isAndroidPlatform) {
        // Playtech requires this on Android platform
        this.checkForRedirect();
      }
      integrator.sendMessage({
        type: 'loginRequired',
      });
    });
    eventBus.$on('TicketPayin', () => {
      if (this.isTerminal) {
        this.ticketPayinTerminal();
      } else {
        this.ticketPayin();
      }
    });
    eventBus.$on('TicketCancel', (ticket) => {
      if (this.isThirdPartyIntegration) {
        this.showTerminalNotification({
          message: this.translations.general_ticket_resolving,
          type: 'info',
          delay: null,
        });
      } else {
        this.checkTicket(ticket.requestUuid, 'Cancel');
      }
      this.busService.sendMessage(
        {
          action: 'Tickets.Cancel',
          data: {
            ticket,
          },
        },
        true,
      );
    });
    eventBus.$on('PayoutTicket', (ticket) => {
      if (this.isThirdPartyIntegration) {
        this.showTerminalNotification({
          message: this.translations.general_ticket_resolving,
          type: 'info',
          delay: null,
        });
        const regulatory = this.config.ui.config?.regulatory;
        const payoutAmount = regulatory?.triggers?.filter((action) => action.type === 'payout')[0].value;
        // ID = 1 MNE RETAIL AUTH
        if (regulatory?.id === 1 && payoutAmount && ticket.possiblePayout >= payoutAmount) {
          this.showTerminalNotification({
            // eslint-disable-next-line dot-notation
            message: this.translations['terminal_regulatory_transaction_payout_amount_exceded']
              .replace('{{amount}}', payoutAmount)
              .replace('{{currency}}', this.config.currency),
            type: 'warning',
            delay: 3000,
          });
          return;
        }
      } else {
        this.checkTicket(ticket.requestUuid, 'Payout');
      }
      this.busService.sendMessage(
        {
          action: 'Tickets.Payout',
          data: {
            ticket,
          },
        },
        true,
      );
    });
    eventBus.$on('LoadLastTickets', () => {
      if (!this.isTerminal) {
        this.getLastTickets();
      }
    });
    eventBus.$on('PrebetCleared', () => {
      this.clearSelection();
      // This is because we want to clear stake and freeBet
      if (!this.ticket.length) this.clearBetslip();
    });
    eventBus.$on('ClearBetslip', () => {
      this.clearSelection();
      this.clearBetslip();
    });
    eventBus.$on('ShowNotification', (notification) => {
      this.busService.sendMessage(
        {
          action: 'Dialog.Show',
          data: notification,
        },
        true,
      );
    });
    eventBus.$on('CloseTicketDetails', () => {
      this.setLoaded(false);
      this.setTicketDetailsData(null);

      if (this.isThirdPartyIntegration) this.setActiveComponent('BettingArea');
      else {
        this.busService.sendMessage(
          {
            action: 'UI.Show',
            data: {
              name: 'BettingArea',
            },
          },
          true,
        );
      }
    });
    eventBus.$on('PrintTicketCopy', (ticket) => {
      const gameName = this.usePackageTranslations ? 'product_name' : 'pages_company_help_virtual_games_lucky_six';
      const mappedTicket = assign(ticket, { isCopy: true }, { translation: this.translations[gameName] });
      const isFuture = this.checkIsTicketFuture(ticket);
      mappedTicket.isFuture = isFuture;
      mappedTicket.parsedResponse = ticket.bets;
      each(mappedTicket.parsedResponse, (bet) => {
        const singleBet = {
          category: 'STANDARD',
          title: null,
          eventValue: null,
          value: null,
        };

        bet.possibleTax = bet.possibleTax || 0;
        if (bet.type === 0) {
          singleBet.title = bet.value;
          singleBet.eventValue = '';
          bet.bet = singleBet;
          bet.eventValue = '';
        }
        bet.displayName = this.translations[this.getBetTypeLabel(bet.type)];
        if ([1, 2, 3, 4].includes(bet.type)) {
          const systemTypes = {
            1: '6/7',
            2: '6/8',
            3: '6/9',
            4: '6/10',
          };
          bet.displayName = `${this.translations.general_ticket_system} ${systemTypes[bet.type]}`;
        }
        bet.displayValue = this.getBetNameLabel(bet);
      });
      this.busService.sendMessage(
        {
          action: 'Peripherals.Print',
          data: {
            type: 'ticket',
            productId: 'LuckySix',
            data: mappedTicket,
          },
        },
        true,
      );
    });
    eventBus.$on('TicketCancelled', async (ticketId) => {
      this.ticketCanceled = true;
      this.canceledTicket = { id: ticketId };
      this.getLastTickets();
      setTimeout(async () => {
        if (this.nextgenStandaloneIntegration) {
          await window.igniteInstance.getWallets().then((result) => {
            if (result.activeCurrencyBalance) {
              this.setUserBalance(result.activeCurrencyBalance);
            }
          });
        }
      }, 1000);
    });

    bus.$on('hideOverlay', () => {
      this.setDisplayOverlay(false);
    });
    if (this.config.platformConfig.clientType) {
      if (this.userProfile && this.userProfile?.profile?.id) {
        this.updatePlayerChannel(this.userProfile.profile.id);
        if (!this.isTerminal) {
          this.getLastTickets();
        }
      }
    }
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  outline-style: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
html,
body {
  background-color: var(--bg-color-1);
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
  -ms-overflow-style: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  scrollbar-width: none;
  //height: 100vh;
  overflow: auto;
  -webkit-text-size-adjust: 100%; /* Prevent font scaling */
  text-size-adjust: 100%;
}

html::-webkit-scrollbar {
  display: none;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

.app {
  display: flex;
  background-repeat: no-repeat;
  background-size: cover;
  float: left;
  width: 100%;
  height: 100%;
  font-family: 'Roboto', sans-serif;

  &.background {
    &.dark {
      background-image: url('assets/L6_bg_dark.jpg');
    }
    &.light {
      background-image: url('assets/L6_bg_light.jpg');
    }
  }

  &.hide-cursor {
    * {
      cursor: none !important;
    }
  }

  .cancel-ticket-wrapper-desktop {
    .cancel-ticket {
      .modal {
        color: var(--text-primary-1);
      }
    }
  }

  .cancel-ticket-confirm,
  .free-bet-expired-modal {
    .modal {
      height: 182px;
    }
  }

  .cancel-ticket-confirm,
  .free-bet-expired-modal,
  .lucky-loser-modal,
  .free-bet-modal {
    z-index: 1000;
    .modal {
      background-color: var(--card);

      .modal-header,
      .modal-body {
        color: var(--text-primary-1);
      }

      .modal-header {
        font-size: 16px;
      }
      .modal-body {
        font-size: 14px;
        .modal-actions {
          display: none;
        }
      }
      .modal-footer {
        padding-right: 43px;
      }
      .button {
        background: transparent;
        border: 0;
        outline: 0;
        font-size: 14px;
        color: var(--secondary);
        text-transform: uppercase;
        cursor: pointer;
        font-family: Roboto, 'sans-serif';
        padding: 31px 0 27px 0;
      }
    }
  }

  .lucky-loser-modal {
    .modal {
      max-height: 348px !important;
      .modal-header {
        display: none;
      }
      .modal-body {
        height: 348px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('assets/confeti.png');
        background-repeat: no-repeat;
        background-position: -11px 7px;
        position: relative;
        text-align: center;

        .body-message-box {
          position: absolute;
          top: 51%;
          left: 50%;
          transform: translate(-50%, -50%);

          .title {
            font-size: 42px;
            font-weight: 700;
            color: #90b653;
            margin-bottom: 25px;
          }
          .subtitle {
            font-size: 18px;
            font-weight: 700;
          }
          .subtitle-2 {
            font-size: 14px;
            color: var(--text-primary-3);
          }
        }

        .action {
          position: absolute;
          bottom: 0;
          right: 16px;
        }
      }
      .modal-footer {
        display: none;
      }
    }
  }

  .free-bet-modal {
    .modal {
      max-height: 348px !important;
      .modal-header {
        display: none;
      }
      .modal-body {
        height: 348px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background-position: 0 0;
        background-repeat: no-repeat;
        position: relative;
        text-align: center;
        .body {
          height: 100%;
          img {
            position: absolute;
            top: -2%;
            left: 22px;
            max-width: 100%;
          }
          .body-message-box {
            position: absolute;
            width: 100%;
            top: 66%;
            left: 50%;
            transform: translate(-50%, -50%);

            .title {
              font-size: 42px;
              font-weight: 700;
              color: #90b653;
              margin-bottom: 25px;
            }
            .subtitle {
              font-size: 18px;
              font-weight: 700;
            }
            .subtitle-2 {
              font-size: 14px;
              color: var(--text-primary-3);
            }
          }
        }
      }
      .modal-footer {
        display: none;
      }
    }
    &.desktop {
      .modal {
        .modal-body {
          background-image: none;
          .body {
            img {
              height: 60%;
              left: 50%;
              top: -2%;
              transform: translate(-50%, 0);
            }
            .body-message-box {
              top: 60%;
              .title {
                margin-bottom: 10px;
              }
              .pre-title {
                display: none;
              }
            }
            .action {
              position: absolute;
              bottom: 0;
              right: 16px;
            }
          }
        }
      }
    }
    &.mobile {
      .modal {
        .modal-body {
          background-image: url('assets/free-bet-bg.svg');
          .body {
            .body-message-box {
              .title {
                text-transform: uppercase;
              }
            }
            .action {
              position: absolute;
              left: 0;
              bottom: 20px;
              display: flex;
              width: 100%;
              justify-content: center;
              align-items: center;
              .button {
                min-width: 150px;
                background: #90b653;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 30px;
                padding: 0;
                color: var(--text-secondary-1);
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 640px) {
  .app {
    .cancel-ticket-confirm .free-bet-expired-modal {
      background-color: var(--overlay-lock);
      .modal {
        background-color: var(--card);
        color: var(--text-primary-1);
        height: 182px !important;

        .modal-header {
          background-color: var(--card);
          padding: 24px 24px 30px 24px;
        }

        .modal-body {
          position: relative;
          padding: 0 24px;
          .modal-actions {
            display: block;
            position: absolute;
            bottom: 0;
            right: 0;
            padding-right: 43px;
          }
        }

        .modal-footer {
          display: none;
        }
      }
    }
    .free-bet-modal {
      .modal {
        max-height: 70% !important;
        .modal-body {
          height: 100% !important;
        }
      }
    }
  }
}

@media (-webkit-device-pixel-ratio: 1.1) {
  .ticket-wrapper {
    zoom: 0.9;
  }
}

@media (-webkit-device-pixel-ratio: 1.25) {
  .ticket-wrapper {
    zoom: 0.8;
  }
}
</style>
